import { HttpErrorResponse } from '@angular/common/http';
import { HttpErrorModel, LoggerService, normalizeHttpError } from '@spartacus/core';

export class HttpPaymentErrorModel extends HttpErrorModel {
  paymentId?: string;
  redirectURL?: string;
}

export function normalizePaymentHttpError(
  error: HttpErrorResponse | HttpErrorModel | any,
  logger: LoggerService
): HttpPaymentErrorModel | undefined {
  const normalizedError = normalizeHttpError(error, logger);

  if (normalizedError instanceof HttpErrorModel && error.error) {
    const normalizedPaymentError = normalizedError as HttpPaymentErrorModel;
    if (typeof error.error === 'string') {
      error.error = JSON.parse(error.error);
    }
    normalizedPaymentError.paymentId = error.error.paymentId;
    normalizedPaymentError.redirectURL = error.error.redirectURL;

    return normalizedPaymentError;
  }

  return normalizedError;
}
